import { Injectable } from '@angular/core';
import { CustomPageConfigService } from 'gung-standard';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SjoborgCustomPageConfigService extends CustomPageConfigService {
  public getDefaultTemplate(type?): Observable<any[]> {
    return super.getDefaultTemplate(type).pipe(
      map(templates => {
        templates.push({
          id: 'startpage',
          name: 'SJOBORG_STARTPAGE'
        });
        return templates;
      })
    );
  }
}
